import { useCallback } from 'react'
import { useGetPlayerChannel } from 'src/store/socket'
import { promisifyPush } from 'src/utils/promisifyPush'
import { useInventoryStore } from '../store'

export const useClaimInventoryItem = () => {
  const playerChannel = useGetPlayerChannel()
  const claimItem = useInventoryStore((state) => state.actions.claimItem)
  const revertClaimItem = useInventoryStore((state) => state.actions.revertClaimItem)

  const claimInventoryItem = useCallback(async (itemId: string) => {
    if (!playerChannel) {
      console.error('No player channel available for claiming item')
      return
    }

    try {
      // Optimistically update the store first
      claimItem(itemId)

      await promisifyPush({
        channel: playerChannel,
        eventName: 'client:player:inventory-item:claim',
        payload: { itemId }
      })
    } catch (error) {
      console.error('Failed to claim inventory item:', error)
      // Revert optimistic update on any error
      revertClaimItem(itemId)
      throw error
    }
  }, [playerChannel, claimItem, revertClaimItem])

  return { claimInventoryItem }
}